import React, { useEffect, useState } from 'react';
import MasterLayout from '../layouts/MasterLayout';
import AppNotification from '../helpers/AppNotification';
import TransactionModel from '../models/TransactionModel';
import Paginate from '../components/paginate/Paginate';
import { RiHistoryLine, RiSearch2Line } from 'react-icons/ri';
import './bank-modern.css';

function TransactionHistoryPage() {
    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const [keyword, setKeyword] = useState({
        start_date: '',
        end_date: '',
    });
    const [filter, setFilter] = useState({
        search: '',
        perPage: perPage,
        page: page,
    });

    const changePage = (pageNum) => {
        setPage(pageNum);
        setFilter({ search: keyword });
    };

    useEffect(() => {
        TransactionModel.history({
            search: filter.search,
            page: page,
            perPage: perPage
        })
            .then(res => {
                setItems(res.data || []);
                setMeta(res.meta || {});
            }).catch(() => {
                AppNotification.showError('Lấy dữ liệu thất bại!');
            });
    }, [page, filter, perPage]);
    
    const handleChange = (event) => {
        setKeyword({
            ...keyword,
            [event.target.name]: event.target.value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setFilter({ search: keyword });
    };

    const handleSetPage = (number) => {
        setPage(page + number);
        setFilter({ search: keyword });
    };

    const getTransactionTypeName = (type) => {
        switch (type) {
            case 'DEPOSITAPP': return 'Nạp tiền vào App';
            case 'RECHARGE': return 'Nạp tiền vào web';
            case 'EARNMONEY': return 'Rút tiền';
            case 'PAYMONEY': return 'Chuyển tiền qua TK chính';
            case 'CHECK': return 'Kiểm tra TK ở App';
            case 'FEETRANSFER': return 'Phí chuyển tiền';
            case 'BUYPACKAGE': return 'Mua gói VIP';
            case 'EDITACCOUTNAPP': return 'Sửa số TK app';
            case 'CREATEACCOUTNAPP': return 'Tạo mới TK app';
            case 'DEPOSITFROMADMIN': return 'Nạp tiền từ Admin';
            case 'DOWLOADBILL': return 'Phí tạo bill app';
            case 'BUYPACKAGEBILL': return 'Mua gói bill';
            case 'DOWLOADNOTI': return 'Tạo Fake thông báo';
            case 'RECHARGECODE': return 'Nạp tiền từ CODE';
            case 'CHECK_BANK_FEE': return 'Phí kiểm tra TK';
            case 'UpdateTransactionHistory': return 'Phí sửa lịch sử GD';
            case 'PushNotification': return 'Phí tạo thông báo GD';
            case 'BUYACCOUNT': return 'Đăng ký tài khoản app';
            case 'REFUND_MONEY': return 'Hoàn tiền cho user';
            case 'RENEWACCOUNT': return 'Gia hạn tài khoản app';
            case 'REFUND_REFERRAL': return 'Hoa hồng giới thiệu';
            default: return type || 'Giao dịch';
        }
    };

    return (
        <MasterLayout>
            <div className="card bank-main-card">
                <div className="bank-card-header">
                    <div className="d-flex align-items-center gap-2">
                        <h5 className="bank-header-title">
                            <RiHistoryLine size={18} />
                            <span>Lịch Sử Chi Tiêu &amp; Giao Dịch</span>
                        </h5>
                    </div>
                    <span className="bank-total-pill">
                        {meta.total || items.length} bản ghi
                    </span>
                </div>

                <div className="card-body p-0">
                    {/* Filter toolbar */}
                    <div className="bank-toolbar">
                        <div className="bank-perpage-wrap">
                            <span>Nhật ký biến động số dư và phí dịch vụ hệ thống</span>
                        </div>
                        <form onSubmit={handleSubmit} className="d-flex align-items-center flex-wrap gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <span style={{ color: 'var(--wus-text-muted)', fontSize: '12.5px' }}>Từ ngày:</span>
                                <input
                                    type="date"
                                    name="start_date"
                                    className="bank-search-input"
                                    style={{ width: '145px', padding: '5px 10px' }}
                                    value={keyword.start_date}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <span style={{ color: 'var(--wus-text-muted)', fontSize: '12.5px' }}>Đến ngày:</span>
                                <input
                                    type="date"
                                    name="end_date"
                                    className="bank-search-input"
                                    style={{ width: '145px', padding: '5px 10px' }}
                                    value={keyword.end_date}
                                    onChange={handleChange}
                                />
                            </div>

                            <button className="bank-search-btn" type="submit">
                                <RiSearch2Line size={14} />
                                <span>Lọc dữ liệu</span>
                            </button>
                        </form>
                    </div>

                    {/* Table */}
                    <div className="bank-table-wrapper">
                        <table className="bank-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '75px', textAlign: 'center' }}>Mã GD</th>
                                    <th>Loại Giao Dịch</th>
                                    <th>Số Tiền</th>
                                    <th>Nội Dung Chi Tiết</th>
                                    <th>Thời Gian</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5" style={{ color: 'var(--wus-text-subtle)' }}>
                                            Không tìm thấy giao dịch nào trong khoảng thời gian này
                                        </td>
                                    </tr>
                                ) : (
                                    items.map((item, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'center', color: 'var(--wus-text-subtle)', fontSize: '12px', fontFamily: 'var(--wus-mono)' }}>
                                                #{item.id}
                                            </td>
                                            <td>
                                                <span className="bank-type-badge">
                                                    {getTransactionTypeName(item.type)}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="table-balance-amount">
                                                    {item.amount_fm} <span className="currency-unit">VNĐ</span>
                                                </span>
                                            </td>
                                            <td style={{ color: 'var(--wus-text-secondary)', fontSize: '13px' }}>
                                                {item.note || '-'}
                                            </td>
                                            <td style={{ color: 'var(--wus-text-muted)', fontSize: '12px', fontFamily: 'var(--wus-mono)', whiteSpace: 'nowrap' }}>
                                                {item.create_at_fm || '-'}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="bank-pagination-wrap">
                        <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                    </div>
                </div>
            </div>
        </MasterLayout>
    );
}

export default TransactionHistoryPage;
